import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { ActionsCellWithBadge } from "../../../../Component/Common/Components/DataTable/ActionsCellWithBadge";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { CommitteeMember } from "../../../../Component/Model/Dto/EmploymentEquity/Committee";
import { TableDateHelper } from "../../../../Component/Model/helpers";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";
import { occupationLevelFormatter } from "../../../../Component/Model/helpers";

interface CommitteeMemberRow {
    Id:                     string;
    FullName:               string;
    OccupationalLevel:      string;
    JobTitle:               string;
    Constituency:           string[];
    DateAppointed:          string;
    Status:                 string;
    SupportingDocuments:    any;
    Actions?:               ActionType[];
}

interface CommitteeMembersTable {
    columns: Array<TableColumn>;
    rows: Array<CommitteeMemberRow>;
}

function getConstituencyStrings(item: CommitteeMember.DtoIn): string[]{
    const constituencies: string[] = [];
    const constituenciesTooltip: string[] = [];
    if (item.isTopManagement){
        constituencies.push("TM");
        constituenciesTooltip.push("Top Management");
    }
    if (item.isSeniorManagement){
        constituencies.push("SM");
        constituenciesTooltip.push("Senior Management");
    }
    if (item.isMiddleManagement){
        constituencies.push("MM");
        constituenciesTooltip.push("Middle Management");
    }
    if (item.isJuniorManagement){
        constituencies.push("JM");
        constituenciesTooltip.push("Junior Management");
    }
    if (item.isSemiSkilled){
        constituencies.push("SS");
        constituenciesTooltip.push("Semi-Skilled");
    }
    if (item.isUnskilled){
        constituencies.push("US");
        constituenciesTooltip.push("Unskilled");
    }
    if (item.isAfrican){
        constituencies.push("AF");
        constituenciesTooltip.push("African");
    }
    if (item.isColoured){
        constituencies.push("CO");
        constituenciesTooltip.push("Coloured");
    }
    if (item.isIndian){
        constituencies.push("IN");
        constituenciesTooltip.push("Indian");
    }
    if (item.isWhite){
        constituencies.push("WT");
        constituenciesTooltip.push("White");
    }
    if (item.isNonSA){
        constituencies.push("NonSA");
        constituenciesTooltip.push("Non South African");
    }
    if (item.isMale){
        constituencies.push("M");
        constituenciesTooltip.push("Male");
    }
    if (item.isFemale){
        constituencies.push("F");
        constituenciesTooltip.push("Female");
    }
    if (item.isDisabled){
        constituencies.push("D");
        constituenciesTooltip.push("Disabled");
    }
    if (item.isUnionRepresentative){
        constituencies.push("UR");
        constituenciesTooltip.push("Union Representative");
    }
    return [constituencies.join(', '), constituenciesTooltip.join(', ') ];
}

export function CommitteeMembersTableMapper(dataObject: CommitteeMember.DtoIn[], handleEdit: (id: string) => void, handleDelete: (id: string) => void, handleAttachedSD: (id: string) => void, handleToggleDocumentPack: (id: string) => void): CommitteeMembersTable {

    const columns = [
        { Header: 'Full Name', accessor: 'FullName', id: "FirstName", Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />},
        { Header: 'Occupational Level', accessor: 'OccupationalLevel', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />, disableSortBy: true },
        { Header: 'Job Title', accessor: 'JobTitle', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} />, disableSortBy: true},
        { Header: 'Constituency Represented', accessor: 'Constituency', Cell: ({ value}: any) => <DefaultCell value={value[1]} tooltip={true} tooltipValue={value[0]}/>, disableSortBy: true },
        { Header: 'Date Appointed', accessor: 'DateAppointed', Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'Status', accessor: 'Status', id:"IsActive", Cell: ({ value }: any) => <DefaultCell value={value} />},
        { Header: 'Supporting Documents', accessor: 'SupportingDocuments', Cell: ({ value }: any) => <ActionsCellWithBadge actions={value}  key={value}/>, disableSortBy: true },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject !== undefined && dataObject.length > 0) {

        const rows = dataObject.map((item: CommitteeMember.DtoIn) => ({
            Id: item.id,
            FullName : item.fullName,
            OccupationalLevel: occupationLevelFormatter(item.occupationalLevelId),
            JobTitle : item.jobTitle,
            Constituency: getConstituencyStrings(item),
            DateAppointed: TableDateHelper(item.dateAppointed),
            Status: item.isActive === true ? "Active": "Resigned on " + (item.dateResigned !== null? TableDateHelper(item.dateResigned) : ""),
            SupportingDocuments: item.documentsSelectedForDownload ? [
                { label: `${item.documentCount} Supporting Document(s)`, action: handleAttachedSD, key: item.id, icon: { color: 'info', name: 'attach_file' }, badgeCount: item.documentCount }
            ] :
                [
                    { label: `${item.documentCount} Supporting Document(s)`, action: handleAttachedSD, key: item.id, icon: { color: 'info', name: 'attach_file' }, badgeCount: item.documentCount }
                ],
            Actions: [
                { label: 'View/Edit', action: handleEdit, key: item.id, icon: { color: 'info', name: 'edit' } },
                { label: 'Delete', action: handleDelete, key: item.id, icon: { color: 'error', name: 'delete' } }]
        }));

        return { columns: columns, rows: rows };

    } else {
        return { columns: columns, rows: [] };
    }
}